<template>
  <div>
    <span class="header-message" @mouseenter="MessageMousEnterHandle" @mouseleave="MessageMousLeaveHandle">
      <Badge :count=2>
        <Icon type="ios-notifications-outline" size="26"></Icon>
        <!-- 加入动画效果 -->
        <el-collapse-transition>
          <message-menu v-if="MsgMenu"/>
        </el-collapse-transition>
      </Badge>
    </span>
    <span class="header-user" @mouseenter="UserMousEnterHandle" @mouseleave="UserMousLeaveHandle">
      <Avatar style="background-color: #87d068; margin: 0 .5rem" icon="ios-person" />
      <span style="margin-right: 1rem">{{this.UserName}}</span>
      <el-collapse-transition>
          <userinfo-menu v-if="UserMenu"/>
      </el-collapse-transition>
    </span>
  </div>
</template>

<script>
import MessageMenu from './compenent/MessageMenu.vue'
import UserInfoMenu from './compenent/UserInfoMenu.vue'

export default {
  name: 'home_header',
  components: {
    'message-menu': MessageMenu,
    'userinfo-menu': UserInfoMenu
  },
  data () {
    return {
      UserName: this.$store.state.userInfo.userName,
      MsgMenu: false,
      hoverCtrl: {},
      UserMenu: false,
      hoverCtrl2: {}
    }
  },
  methods: {
    MessageMousEnterHandle () {
      clearTimeout(this.hoverCtrl)
      // 当用户的鼠标移入消息图标的时候，显示消息菜单
      this.hoverCtrl = setTimeout(() => {
        this.MsgMenu = true
      }, 200)
    },
    MessageMousLeaveHandle () {
      clearTimeout(this.hoverCtrl)
      // 当用户的鼠标离开消息图标的时候，隐藏消息菜单
      this.hoverCtrl = setTimeout(() => {
        this.MsgMenu = false
      }, 500)
    },
    UserMousEnterHandle () {
      clearTimeout(this.hoverCtrl2)
      this.hoverCtrl2 = setTimeout(() => {
        this.UserMenu = true
      }, 200)
    },
    UserMousLeaveHandle () {
      clearTimeout(this.hoverCtrl2)
      this.hoverCtrl2 = setTimeout(() => {
        this.UserMenu = false
      }, 500)
    }
  }
}
</script>
<style scoped>
  .header-message >>> .ivu-badge-count{
    margin-top: 15px;
    margin-right: 0px;
  }
  .header-message{
    margin-right: 1rem;
    position: relative;
  }
  .header-user{
    position: relative;
  }
</style>>
